import { render, staticRenderFns } from "./ChangeVersion.vue?vue&type=template&id=5549a7d5&"
import script from "./ChangeVersion.vue?vue&type=script&lang=ts&"
export * from "./ChangeVersion.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VOverflowBtn } from 'vuetify/lib/components/VOverflowBtn';
installComponents(component, {VListItem,VListItemTitle,VOverflowBtn})
